export default {"src":"/_next/static/media/insurance.4051b21f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};